export default __webpack_public_path__ + "static/body-v2-02-chest-81913131c8b6399cd23d9d964b0dbbd9.png";